export default {
	footerContainer: {
		backgroundColor: 'white',
		height: '5vh',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		fontWeight: 'bold'
	},
	footerEmoji: {
		fontSize: '1.5rem',
		margin: '0 1rem'
	}
};
